export enum SalesRuleTabType {
  DETAILS = 'details',
  PRODUCTS = 'products',
  ZONE_REQUIREMENTS = 'zone_requirements'
}

interface ExtensionArea {
  product_group: string
  zone_map: string[]
}

interface ZoneRequirement {
  zone_map: string[]
  required_one_of_existing_products: ExtensionArea[]
}

export interface SalesRule {
  id: string
  created_timestamp: Date
  modified_timestamp: Date
  name: string
  zone_requirements: ZoneRequirement[]
  product_codes: string[]
}

export interface FetchSalesRuleListParams {
  count?: number
  case_sensitive?: boolean
  filter?: string
  search_text?: string
  bypass_pagination?: boolean
  sort_by?: string
  sort_order?: string
  start_index?: string
  zone_requirements?: string
}
